var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOoredoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.5 120",
    style: {
      enableBackground: "new 0 0 127.5 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.1,72.1C0,45.8,21.1,24.4,47.4,24.3c26.5-0.1,48,21.3,48.1,47.8c0.1,26.2-21.1,47.5-47.6,47.6 C21.2,120,0.2,99.1,0.1,72.1z M20.1,72.3c0.1,15.3,12.3,27.5,27.5,27.5c15.1,0,27.7-12.3,27.9-27.4c0.2-14.9-13.1-28.3-28-28 C32.3,44.7,20,57.2,20.1,72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,0.2c9.8,0.1,16.8,7.3,16.7,17.2c-0.1,9.8-7.5,16.9-17.2,16.7c-9.1-0.2-16.7-7.9-16.6-16.9 C93.7,7.7,101.3,0.2,110.8,0.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOoredoo);
export default __webpack_public_path__ + "static/media/ooredoo.73f2e8c1b9d0912776463264efb6ffb0.svg";
export { ForwardRef as ReactComponent };